import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type DeployConfirmationModalProps = {
  templateName: string;
  deploymentName: string;
  onDeploy: () => void;
};

const DeployConfirmationModal = create(function DeployConfirmationModal({
  templateName,
  deploymentName,
  onDeploy,
}: DeployConfirmationModalProps) {
  const modal = useModal();

  const handleConfirmAction = () => {
    onDeploy();
    modal.hide();
  };

  return (
    <ConfirmationModal
      title="Confirm deployment"
      onConfirm={handleConfirmAction}
      confirmationButtonVariant="primary"
      confirmationButtonLabel="Deploy"
    >
      <ConfirmationModalMessage>
        You&apos;re about to deploy <strong>{deploymentName}</strong> using the{" "}
        <strong>{templateName}</strong> template.{" "}
        <strong>This will provision real infrastructure.</strong>
      </ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showDeployConfirmationModal = (props: DeployConfirmationModalProps) =>
  show(DeployConfirmationModal, props);